export class Address {

  public address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  latitude: string;
  longitude: string;

  constructor(public data: any) {
    const json: JSON = data;

    this.address1 = json['address1'];
    this.address2 = json['address2'];
    this.city = json['city'];
    this.state = json['state'];
    this.zip = json['zip'];
    this.country = json['country'];
    this.latitude = json['latitude'];
    this.longitude = json['longitude'];
  }
}



// WEBPACK FOOTER //
// ./src/app/model/address.ts